import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Login.css';

const unitLogo = '/images/LP_Unit_logo.png';

function DiscordCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleDiscordCallback } = useAuth();
  const [status, setStatus] = useState('Processing Discord login...');
  const [error, setError] = useState(null);
  const hasProcessed = useRef(false); // Prevent double-execution in StrictMode

  useEffect(() => {
    const processCallback = async () => {
      // Prevent double-execution
      if (hasProcessed.current) return;
      hasProcessed.current = true;

      const code = searchParams.get('code');
      const errorParam = searchParams.get('error');
      const errorDescription = searchParams.get('error_description');

      if (errorParam) {
        setError(errorDescription || 'Discord authorization was denied');
        return;
      }

      if (!code) {
        setError('No authorization code received from Discord');
        return;
      }

      try {
        setStatus('Exchanging authorization code...');
        const result = await handleDiscordCallback(code);

        if (result.success) {
          setStatus('Login successful! Redirecting...');
          setTimeout(() => navigate('/'), 1000);
        } else {
          setError(result.message || 'Failed to complete Discord login');
        }
      } catch (err) {
        console.error('Discord callback error:', err);
        setError(err.message || 'An error occurred during Discord login');
      }
    };

    processCallback();
  }, [searchParams, handleDiscordCallback, navigate]);

  return (
    <div className="login-page">
      <div className="login-background" style={{ backgroundImage: `url(/images/coming_soon_bg.png)`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <div className="login-overlay"></div>
      </div>

      <div className="login-container">
        <div className="login-card">
          <img src={unitLogo} alt="Creature Supply Logo" className="login-logo" />
          <h1 className="login-title">Creature Supply</h1>

          {error ? (
            <>
              <div className="error-message">{error}</div>
              <button
                className="discord-btn"
                onClick={() => navigate('/login')}
                style={{ marginTop: '1rem' }}
              >
                Return to Login
              </button>
            </>
          ) : (
            <div className="discord-processing">
              <div className="processing-spinner"></div>
              <p className="processing-status">{status}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default DiscordCallback;
